<template>
	<Teleport to="body">
		<Transition name="modal">
			<div v-if="isModalOpen" class="modal" :style="{ maxWidth: maxWidth }">
				<div class="modal__container">
					<div class="modal__header">
						<UIHeading v-if="title" level="4" class="modal__title">
							{{ title }}
						</UIHeading>
						<button type="button" class="modal__close" @click="isModalOpen = false">
							<Icon name="mdi:close" size="24" />
						</button>
					</div>
					<slot name="content"></slot>
				</div>
			</div>
		</Transition>
		<LayoutCover v-model:is-open="isModalOpen" />
	</Teleport>
</template>

<script setup lang="ts">
	const isModalOpen = defineModel<boolean>('isModalOpen')

	defineProps({
		title: {
			type: String,
			default: '',
		},
		maxWidth: {
			type: String,
			default: '500px',
		},
	})
</script>

<style scoped lang="scss">
	.modal-enter-active,
	.modal-leave-active {
		transition: opacity 0.3s;
	}
	.modal-enter-from,
	.modal-leave-to {
		opacity: 0;
	}
	.modal {
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 2000;
		width: calc(100% - 32px);
		max-width: 500px;
		overflow: hidden;
		border-radius: 10px;
		background-color: var(--white);
		transform: translate(-50%, -50%);

		// @media (width <= 575.98px) {
		// 	// max-width: calc(100% - 32px);
		// 	// width: calc(100% - 32px);
		// 	padding: 32px 16px;
		// }
		&__close {
			position: absolute;
			top: 16px;
			right: 16px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 4px;
			color: var(--black);
			border: 1px solid var(--gray);
			border-radius: 50%;
			opacity: 0.3;
			transition: 0.4s opacity;
			&:hover {
				opacity: 0.8;
			}
		}
		&__header {
			text-align: center;
		}
		&__title{
			margin-top: 32px;
			@media (width <= 575.98px) {
				margin-top: 16px;
			}
		}
		&__container {
			overflow: clip overlay;
			max-height: calc(100svh - 64px);
		}
	}
</style>
